const getHighlights = (state) => {
  return state.annotations
    .filter(ann => ann.text.length === 0)
    .sort((a, b) => a.page > b.page)
}

const getNotes = (state) => {
  return state.annotations
    .filter(ann => ann.text.length > 0)
    .sort((a, b) => a.page > b.page)
}

export default {
  getHighlights,
  getNotes
}
